import {
  RecurringSessionConflictError,
  SessionConflictError,
} from "@classview/shared-types";

type BadRequest = {
  error: string;
  statusCode: 400;
  message: string[];
};

type HttpError =
  | {
      error: string;
      statusCode: number;
      message: string[];
    }
  | BadRequest;

function isBadRequest(error: HttpError): error is BadRequest {
  return error.statusCode === 400;
}

function isSessionConflict(
  error: HttpError | SessionConflictError,
): error is SessionConflictError {
  return error.statusCode === 409;
}

function isRecurringSessionConflict(
  error: HttpError | RecurringSessionConflictError,
): error is RecurringSessionConflictError {
  return error?.statusCode === 409;
}

type AmplifyError = { code: string; message: string };

export { isBadRequest, isRecurringSessionConflict, isSessionConflict };
export type { AmplifyError, HttpError };
